module.exports = __webpack_public_path__ + "img/icon_pen_white.d2e2b46.svg";